import { useState } from "react";
import ls from 'localstorage-slim'
/**
 * Custom hook for uploading a file and initiating a chat.
 * @returns An object containing the fileUploadChat function, data, and loading state.
 */
const useFileUploadChat = () => {
  const [data, setData] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const API_URL =
    "";

  /**
   * Uploads a file and initiates a chat.
   * @param chatHistory - The chat history.
   * @param approach - The approach for the chat.
   * @param filename - The name of the file being uploaded.
   */
  const fileUploadChat = async (
    chatHistory: any,
    approach: string,
    filename: string,
  ) => {
    try {
      const userdata = ls.get('token-gpt-app')
      //@ts-ignore
      const username = userdata.email.split('@')[0]
      const requestBody: any = {
        "username": username,
        "history": chatHistory,
        "approach": approach,
        "app": "knowledge_ai",
        "source_page": "metadata",
        "search_key": "C8B0F78B75376492F69196CC639D4CA7",
        "content_field": "content",
        "search_service": "aimlcontextualsearch",
        "search_index": "quick-chat-index",
        "quick_chat": true,
        "file_name": filename,
        "overrides": {
            "semantic_ranker": true,
            "semantic_captions": false,
            "top": 25,
            "prompt_default_template": "<|im_start|>system         Assistant helps the user with questions about document content listed in the sourced below. Be brief in your answers.        Answer ONLY with the facts listed in the list of sources below. If there isn't enough information below, say you don't know. Do not generate answers that don't use the sources below. If asking a clarifying question to the user would help, ask the question.        For tabular information return it as an html table. Do not return markdown format.        Each source has a name followed by colon and the actual information, always include the source name for each fact you use in the response. Use square brakets to reference the source, e.g. [info1.pdf]. Don't combine sources, list each source separately, e.g. [info1.txt][info2.pdf].        {injected_prompt}        Sources:        {sources}        <|im_end|>        {chat_history}        ",
            "suggest_followup_questions": true,
            "operators": "false",
            "fake_data": "false",
            "entities": [],
            "anonymization_operators": []
        }
    }
      setData(null);
      setLoading(true);
      const responseFetch = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const reader = responseFetch?.body?.pipeThrough(new TextDecoderStream()).getReader();
      while (true) {
        if(reader === undefined) break;
        const { done, value } = await reader?.read();
        if (done) break;
        console.log(value);
        setData(value)
      }
    //   setData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { fileUploadChat, data, loading };
};

export default useFileUploadChat;
